import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="e3didugelir3">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9cszrbcd83e">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="8bch7bk3tea">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-51" data-mp="57xr9l719hp7">
            Un modo migliore di insegnare musica
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-52" data-mp="3rg76ion8g51d">
            Da Insegnante Sopraffatto a{' '}
            <span className="italic text-grape" data-id="element-53" data-mp="3diqxr6hgrz6g">Guida Sicura.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-navy/60 sm:text-base" data-id="element-54" data-mp="3igam4z7vlsc4">
            Musica Pronta trasforma ore di pianificazione in un sistema «apri e
            insegna». Entra in ogni lezione con un piano chiaro, attività
            significative e la sicurezza necessaria per far vivere la musica ai
            tuoi studenti.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-55" data-mp="1f8shrn26tfha">
          <div className="grid md:grid-cols-2" data-id="element-56" data-mp="1t18ey78eqjaa">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-57" data-mp="1t32ybh4163c9">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy/35" data-id="element-58" data-mp="1o2x5hxm0yasl">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="10edxlj6w0011" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-navy/40" data-id="element-60" data-mp="wciuc95ebckm">
                Il costo di partire da zero ogni giorno
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-61" data-mp="15amh18s4afe0">
                PRIMA
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-62" data-mp="2lrgwbwv4cznt">
                Il vecchio modo stancante.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-63" data-mp="2oq7dixnm0wna">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/80 px-4 py-3 text-sm text-navy/60" data-id="element-64" data-mp="2ss2oktvceoe9">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/30" aria-hidden="true" data-id="element-65" data-mp="32rjtva6on09p" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-66" data-mp="2a003n6bo4ly7">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-67" data-mp="2f0nu9qvzj0rw">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="2jtz480w3fxo1" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-69" data-mp="1manug6gccdvw">
                Il sistema Musica Pronta
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-70" data-mp="1jrau4qve2wt9">
                CON MUSICA PRONTA
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-71" data-mp="19u624aev474j">
                La tua nuova realtà.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-72" data-mp="14u1lmkdyfceb">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-navy-light px-4 py-3 text-sm font-medium text-navy" data-id="element-73" data-mp="10tq1d8pi7e3d">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-74" data-mp="r2vfw6k30iiz" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-navy/5 bg-cream px-6 py-4 text-center text-xs text-navy/50" data-id="element-75" data-mp="d45kcvcwuqwq">
            Un sistema completo per pianificare meno e insegnare con più senso.
          </p>
        </div>
      </div>
    </section>;
}